module.exports = __webpack_public_path__ + "img/backImage@2x.926953f7.png";